import React, {useState, useCallback} from "react";

import withStyles from '@material-ui/core/styles/withStyles';
import {
    Create,
    FormTab,
    Edit,
    TextInput,
    TabbedForm,
    AutocompleteInput,
    SelectInput,
    DateInput,
    TopToolbar,
    ReferenceInput,
    Toolbar, SaveButton, DeleteButton,
    useGetOne, Loading, NumberInput, TextField, ShowButton, required, maxLength
} from 'react-admin';
import {makeStyles} from "@material-ui/core";



const useStyles = makeStyles((theme) => ({
    unidad_medida: {display: 'inline-block', width: 200, marginLeft: 8},
    unidad_medida_d: {display: 'inline-block', width: 600, marginLeft: 108},
    unidad_medida_abre: {display: 'inline-block', width: 200, marginLeft: 8},
    codigo_afip: {display: 'inline-block', width: 200, marginLeft: 108},
    codigo_gestion: {display: 'inline-block', width: 200, marginLeft: 8},
}));

const validateunidad_medida = [required(), maxLength(10)];
const validateunidad_medida_d = [required(), maxLength(60)];
const validateunidad_medida_abre = [maxLength(6)];
const validatecodigo_afip = [maxLength(10)];
const validatecodigo_gestion = [maxLength(10)];


const UniMedEdit = props => {
    const classes = useStyles();
    const [state, setState] = useState({});
    const [UniMed, setUniMed] = useState('');
    const [PersonaTipo, setPersonaTipo] = useState('');

    /// Búsqueda país
    var w_pais_legal = '', w_pais_comercial = '';

    const {data: Data, loading: Loading} = useGetOne('UniMed', props.id);

    if (Data === undefined) {
    } else {
        w_pais_legal = Data.legal_pais;
        w_pais_comercial = Data.PaisComercial ? Data.PaisComercial.pais.trim() : '';
    }

    const {
        PaisLegal = w_pais_legal, PaisComercial = w_pais_comercial,
    } = state;

    const formatPaisLegal = v => {
        return PaisLegal
    };

    const formatPaisComercial = v => {
        return PaisComercial
    };

    const updatePaisLegal = useCallback(async (who) => {
        setState(state => ({
            ...state,
            pais_codigo_afip_legal: who.pais_codigo_afip,
            PaisLegal: who.pais.trim(),
        }));
    })


    const updatePaisComercial = useCallback(async (who) => {
        setState(state => ({
            ...state,
            pais_codigo_afip_comercial: who.pais_codigo_afip,
            PaisComecial: who.pais.trim(),
        }));
    })

    const establecerUniMed = value => {
        if (value == null || value === '') return '';
        setUniMed(value.trim());
        return value;
    };

    const establecerFecha = value => {
        if (value == null || value === '') return '';
        return value;
    };

    // Obtengo tipo de persona para cargar solapa correspondiente
    const establecerPersonaTipo = value => {
        if (value == null || value === '') return '';
        setPersonaTipo(value.trim());
        return value;
    };

    const cuitCuilFormat = value => {
        if (value == null || value === '') return '';

        //normalize string and remove all unnecessary characters
        var valueCuit = value.replace(/[^\d]/g, "");

        //check if number length equals to 11
        if (valueCuit.length == 11) {
            return value.replace(/(\d{2})(\d{8})(\d{1})/, "$1-$2-$3");
        }

        return value
    };

    const PostEditActions = ({basePath, data, resource}) => (
        <TopToolbar>
            <ShowButton basePath={basePath} record={data}/>
        </TopToolbar>
    );

    const redirect = (basePath, id, data) => `/UniMed`;

    const CustomToolbar = props => (

        <Toolbar {...props}>
            <SaveButton
                label="Actualizar"
                transform={transform}
                submitOnEnter={false}
                disabled={props.pristine}
            />
            <DeleteButton undoable={false} redirect={redirect}/>
        </Toolbar>
    );
    const transform = data => {
        return {
            ...data
        }
    };

    const PostTitle = ({record}) => {
        return <span>Unidad Medida: {record ? `${record.unidad_medida_d}` : ''}</span>;
    };

    return (
        <Edit title={<PostTitle/>} actions={<PostEditActions/>} {...props}>
            <TabbedForm
                redirect={redirect}
                toolbar={<CustomToolbar/>}
            >
                {/*Datos*/}
                <FormTab label="DATOS UNIDAD MEDIDA">
                    <TextInput
                        label="Código Unidad Medida"
                        source="unidad_medida"
                        formClassName={classes.unidad_medida}
                        placeholder="Ingrese Código Unidad Medida"
                        helperText="Código Unidad Medida"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        validate={validateunidad_medida}
                    />

                    <TextInput
                        label="Descripción Unidad Medida"
                        source="unidad_medida_d"
                        formClassName={classes.unidad_medida_d}
                        placeholder="Ingrese Descripción Unidad Medida"
                        helperText="Descripción Unidad Medida"
                        margin="normal"
                        fullWidth={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        validate={validateunidad_medida_d}
                    />

                    <br/>

                    <TextInput
                        label="Unidad Medida Abre."
                        source="unidad_medida_abre"
                        formClassName={classes.unidad_medida_abre}
                        placeholder="Ingrese Unidad Medida Abre."
                        helperText="Unidad Medida Abre."
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        validate={validateunidad_medida_abre}
                    />

                    <TextInput
                        label="Código AFIP"
                        source="codigo_afip"
                        formClassName={classes.codigo_afip}
                        placeholder="Ingrese Código AFIP"
                        helperText="Código AFIP"
                        margin="normal"
                        fullWidth={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        validate={validatecodigo_afip}
                    />


                    <TextInput
                        label="Código Gestion"
                        source="codigo_gestion"
                        formClassName={classes.codigo_gestion}
                        placeholder="Ingrese Código Gestion"
                        helperText="Código Gestion"
                        margin="normal"
                        fullWidth={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        validate={validatecodigo_gestion}
                    />


                </FormTab>
            </TabbedForm>
        </Edit>
    )
};
export default UniMedEdit;


